import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL 
  ? `${process.env.REACT_APP_API_URL}/api` 
  : (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' 
      ? 'http://localhost:5000/api' 
      : 'https://sudip-portfoili.onrender.com/api');

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
  timeout: 10000,
});

export const resolveImageUrl = (imageUrl) => {
  if (!imageUrl || /^(https?:|data:|blob:)/i.test(imageUrl)) return imageUrl;
  const serverOrigin = API_BASE.replace(/\/api\/?$/, '');
  return `${serverOrigin}/${imageUrl.replace(/^\/+/, '')}`;
};

// Profile
export const getProfile = () => api.get('/profile');
export const updateProfile = (data, adminKey) =>
  api.put('/profile', { ...data, adminKey });

// Projects
export const getProjects = (params = {}) => api.get('/projects', { params });
export const createProject = (data, adminKey) =>
  api.post('/projects', { ...data, adminKey });
export const updateProject = (id, data, adminKey) =>
  api.put(`/projects/${id}`, { ...data, adminKey });
export const deleteProject = (id, adminKey) =>
  api.delete(`/projects/${id}`, { params: { adminKey } });

// Messages
export const sendMessage = (data) => api.post('/messages', data);
export const getMessages = (adminKey) =>
  api.get('/messages', { params: { adminKey } });
export const markMessageRead = (id, adminKey) =>
  api.patch(`/messages/${id}/read`, { adminKey });
export const deleteMessage = (id, adminKey) =>
  api.delete(`/messages/${id}`, { data: { adminKey } });

// Gallery
export const getGalleryImages = (params = {}) => api.get('/gallery', { params });
export const createGalleryImage = (data, adminKey) =>
  api.post('/gallery', { ...data, adminKey });
export const updateGalleryImage = (id, data, adminKey) =>
  api.put(`/gallery/${id}`, { ...data, adminKey });
export const deleteGalleryImage = (id, adminKey) =>
  api.delete(`/gallery/${id}`, { data: { adminKey } });

// Upload
export const uploadImage = (payload) => api.post('/upload', payload);

export default api;
